export default __webpack_public_path__ + "static/media/725e0881999200f80f03a4901e2c874d.ec0a51bc.svg";